const CreateInitiativeAction = {
	Request: 'CreateInitiativeActionRequest',
	Success: 'CreateInitiativeActionSuccess',
	Failure: 'CreateInitiativeActionFailure'
};

const CreateConsultationInitiativeAction = {
	Request: 'CreateConsultationInitiativeActionRequest',
	Success: 'CreateConsultationInitiativeActionSuccess',
	Failure: 'CreateConsultationInitiativeActionFailure'
};

function createInitiative(initiative) {
	return {
		type: CreateInitiativeAction.Request,
		payload: initiative
	};
}

function createConsultationInitiative(initiative) {
	return {
		type: CreateConsultationInitiativeAction.Request,
		payload: initiative
	};
}

export const InitiativeActionCreators = {
    createInitiative,
    createConsultationInitiative
};

export const InitiativeActions = {
    CreateInitiativeAction,
    CreateConsultationInitiativeAction
};
